import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useLocationsAsOptions({ type, subtype }) {
  const queryKey = ['locationOptions', type, subtype];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => {
      const json = [
        type && { $match: { type } },
        subtype && { $match: { subtype } },
        {
          $graphLookup: {
            from: 'groups',
            startWith: '$groupCodes',
            connectFromField: 'parentCodes',
            connectToField: 'code',
            as: 'groupAncestorCodes',
          },
        },
        {
          $project: {
            label: '$name',
            value: '$code',
          },
        },
        { $sort: { label: 1 } },
      ].filter(Boolean);

      return api.post('pipeline/locations', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
